export default class BookingCombobox extends HTMLElement {
    constructor(m) {
        super(m);

        /* Binding */
        this.onComboboxKeyDown = this.onComboboxKeyDown.bind(this);
        this.onComboboxClick = this.onComboboxClick.bind(this);
        this.onBackgroundMouseUp = this.onBackgroundMouseUp.bind(this);
        this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);
        this.onComboboxFocusout = this.onComboboxFocusout.bind(this);

        /* UI */
        this.$input = this.querySelector('[data-combobox-input]');
        this.$dialog = this.querySelector('[data-combobox-dialog]');

        /* Data */
        this.openCallback = () => {};
        this.isFromClick = false;
    }

    // =============================================================================
    // Lifecycle methods
    // =============================================================================
    connectedCallback() {
        this.bindEvents();
    }

    disconnectedCallback() {
        this.unbindEvents();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        this.$input.addEventListener('keydown', this.onComboboxKeyDown);
        this.$input.addEventListener('click', this.onComboboxClick);
        this.addEventListener('focusout', this.onComboboxFocusout);

        document.body.addEventListener('mouseup', this.onBackgroundMouseUp, true);
        document.documentElement.addEventListener('keydown', this.onDocumentKeyDown);
    }

    unbindEvents() {
        this.$input.removeEventListener('keydown', this.onComboboxKeyDown);
        this.$input.removeEventListener('click', this.onComboboxClick);
        this.removeEventListener('focusout', this.onComboboxFocusout);

        document.body.removeEventListener('mouseup', this.onBackgroundMouseUp, true);
        document.documentElement.removeEventListener('keydown', this.onDocumentKeyDown);
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onComboboxKeyDown(event) {
        if (event.ctrlKey || event.shiftKey) return;

        switch (event.key) {
            case 'ArrowDown':
                this.open();
                event.stopPropagation();
                event.preventDefault();
                break;

            case 'Tab':
                this.close();
                break;

            default:
                break;
        }
    }

    onComboboxClick(event) {
        if (this.isOpenCombobox()) {
            this.close();
        } else {
            this.open();
        }
    }

    onBackgroundMouseUp(event) {
        if (!this.$input.contains(event.target) && !this.$dialog.contains(event.target)) {
            if (this.isOpenCombobox()) {
                this.close();
            }
        }
    }

    onDocumentKeyDown(event) {
        if (this.isEscapeEvent(event)) {
            if (this.isOpenCombobox()) {
                this.close();
            }
        }
    }

    onComboboxFocusout(event) {
        // If focus is still in the form, do nothing
        if (this.contains(event.relatedTarget)) return;
        this.close();
    }

    // =============================================================================
    // Methods
    // =============================================================================
    open() {
        this.$dialog.style.display = 'block';
        this.$input.setAttribute('aria-expanded', 'true');

        this.openCallback();

        // Focus the first focusable element in the newly added room
        requestAnimationFrame(() => {
            const $focusableEls = this.$dialog.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            $focusableEls[0].focus();
        });
    }

    close() {
        this.$dialog.style.display = 'none';
        this.$input.setAttribute('aria-expanded', 'false');
    }

    isOpenCombobox() {
        return window.getComputedStyle(this.$dialog).display !== 'none';
    }

    isEscapeEvent(event) {
        return event?.key === 'Escape' || event?.key === 'Esc' || event?.keyCode === 27;
    }
}
